<template>
  <div>
    <v-dialog v-model="flag" max-width="500px" max-height="490px" scrollable>
      <v-card
        max-height="490"
        class="white"
        :class="isMac ? 'edited_scrollbar' : ''"
      >
        <!-- Title -->
        <v-card-title class="px-1 text-truncate dialog-title-border">
          <div class="d-flex justify-center float-left" style="width: 90%">
            <span
              class="d-inline-block text-truncate"
              style="max-width: 300px"
              :style="$vuetify.breakpoint.xs ? 'max-width: 100px;' : ''"
            >
              <b class="dark-purple-text modals-title-size"> Create Project </b>
            </span>
          </div>
          <div
            class="d-flex justify-end align-center float-right"
            style="width: 10%; height: 32px"
          >
            <v-icon
              small
              color="#757096"
              @click="flag = false"
              class="d-flex mr-2"
            >
              mdi-close
            </v-icon>
          </div>
        </v-card-title>
        <v-card-text class="py-2">
          <!-- New project -->
          <div class="sticky-header white">
            <div class="font-weight-bold dark-purple-text body-1">
              Create New Project
            </div>
            <div class="theme-border rounded mt-3">
              <v-text-field
                autocomplete="off"
                autofocus
                background-color="white"
                placeholder="Project Name"
                color="#DCD8F3"
                hide-details
                dense
                flat
                solo
                v-model="newProject"
                @keydown.enter="createProject"
              >
                <template slot="append">
                  <v-icon
                    @click="createProject"
                    small
                    class="mt-1"
                    color="#2a206a"
                    >mdi-check</v-icon
                  >
                </template>
              </v-text-field>
            </div>
            <div class="white py-2">
              <div class="font-weight-bold dark-purple-text body-1">
                All Projects
              </div>
              <!-- Project Search -->
              <div class="theme-border rounded mt-3">
                <v-text-field
                  autocomplete="off"
                  prepend-inner-icon="mdi-magnify"
                  background-color="white"
                  placeholder="Search Project"
                  color="#DCD8F3"
                  hide-details
                  dense
                  flat
                  solo
                  v-model="searchProject"
                />
              </div>
            </div>
          </div>
          <!-- Project List -->
          <v-list max-height="230" class="y-scroll my-2">
            <div
              style="height: 100px"
              class="w-100 d-flex align-center justify-center mt-2"
              v-if="searchProject && !filteredProjects.length"
            >
              <span class="t-color my-1 dusty-purple-text"
                >No results found</span
              >
            </div>
            <div
              v-else
              class="py-3 light-grey-border-bottom d-flex align-center"
              v-for="project in filteredProjects"
              :key="project.id"
            >
              <ProfileImage
                inline
                v-show="project.image ? ':src' : ':username'"
                :src="project.image"
                :username="project.name ? project.name : project.email"
                :size="32"
                :circular="true"
                :userProfile="true"
                class="mr-3 text-light"
              >
              </ProfileImage>
              <span class="body-2 dusty-purple-text text-capitalize">{{
                project.name
              }}</span>
            </div>
          </v-list>
        </v-card-text>
        <!-- Snackbars -->
        <Snackbar
          :snackbar.sync="snackbar"
          :snackbarError="snackbarError"
          :snackbarMessage="snackbarMessage"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { snackbarMixin } from "@/mixins/snackbarMixin";
export default {
  components: {
    ProfileImage: () => import("@/components/Includes/ProfileImage"),
    Snackbar: () => import("@/components/Includes/SnackbarNew")
  },
  mixins: [snackbarMixin],
  data() {
    return {
      flag: true,
      searchProject: null,
      newProject: null
    };
  },
  watch: {
    flag(value) {
      !value ? this.$emit("update:openProjectDialog", false) : () => {};
    }
  },
  computed: {
    ...mapGetters([
      "getLoggedInUser",
      "getAllMembers",
      "getProjects",
      "getSelectedCompany"
    ]),
    filteredProjects() {
      return this.searchProject
        ? this.getProjects.filter(item => {
            return item.name.toLowerCase().includes(this.searchProject);
          })
        : this.sort();
    }
  },
  methods: {
    sort() {
      this.getProjects.sort((a, b) =>
        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
      );
      return this.getProjects;
    },
    //create project
    createProject(autoStart) {
      if (this.newProject) {
        this.$store.commit("setSelectedProject", this.newProject);
        this.$store
          .dispatch("createProject", {
            project_name: this.newProject,
            company_id: this.getSelectedCompany.id
          })
          .then(response => {
            this.newProject = null;
            this.openSnackbar(false, response.error_msg);
            this.$store.dispatch("fetchProjects");
          })
          .catch(error => {
            this.$store.commit("setSelectedProject", null);
            if (error && ('errors' in error.response.data)) {
              this.openSnackbar(true,
                error.response.data.errors.project_name[0]
              );
            }
            else{
               this.openSnackbar(true,
                error.response.data.error_msg
              );
            }
            // }
            this.newProject = null;
          });
      }
    }
  },
  mounted() {
    this.$store.dispatch("fetchProjects");
  }
};
</script>

<style scoped>
.light-grey-border-bottom {
  border-bottom: 0.75px solid #eff4ff;
}
.sticky-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}
</style>